import { render, staticRenderFns } from "./payment-confirmation.vue?vue&type=template&id=54598b26&scoped=true&"
import script from "./payment-confirmation.vue?vue&type=script&lang=js&"
export * from "./payment-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54598b26",
  null
  
)

export default component.exports